import { z } from "zod";

/** Emprise d'un lieu, quand l'annuaire la connaît : de quoi cadrer la carte. */
export const envelopeSchema = z.object({
  south: z.number().min(-90).max(90),
  west: z.number().min(-180).max(180),
  north: z.number().min(-90).max(90),
  east: z.number().min(-180).max(180),
});

export type EnvelopeDto = z.infer<typeof envelopeSchema>;

export const placeSchema = z.object({
  label: z.string().min(1).max(200),
  context: z.string().max(200).nullable(),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  envelope: envelopeSchema.nullable(),
});

export type PlaceDto = z.infer<typeof placeSchema>;

export const searchPlacesQuerySchema = z.object({
  q: z.string().min(2).max(120),
});

export type SearchPlacesQuery = z.infer<typeof searchPlacesQuerySchema>;

export const searchPlacesResponseSchema = z.object({
  places: z.array(placeSchema),
});

export type SearchPlacesResponse = z.infer<typeof searchPlacesResponseSchema>;
